import React from "react";
import { Box, ButtonBase, SxProps, Typography } from "@mui/material";
import { Mail } from "@mui/icons-material";

interface Props {
  sx?: SxProps;
}

const Address: React.FC<Props> = ({ sx }) => {
  return (
    <Box
      sx={{
        borderRadius: 1,
        bgcolor: "secondary.light",
        p: { xs: 2, sm: 4 },
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="h5"
            color="text.primary"
            sx={{
              fontWeight: "900",
              fontSize: { xs: "h6.fontSize", sm: "h5.fontSize" },
            }}
          >
            Ansökan
          </Typography>
          <Typography
            variant="body1"
            color="text.primary"
            sx={{
              fontWeight: "700",
              fontSize: { xs: "body2.fontSize", sm: "body1.fontSize" },
              mb: 3,
            }}
          >
            Senast den 15 maj varje år
          </Typography>
          <Typography
            variant="body1"
            color="text.primary"
            sx={{
              fontWeight: "400",
              fontSize: { xs: "body2.fontSize", sm: "body1.fontSize" },
              lineHeight: 1,
              mb: 1,
            }}
          >
            Skickas via mail
          </Typography>
          <Box>
            <ButtonBase
              href="mailto:info@margottobis.se"
              sx={{
                color: "text.primary",
                fontWeight: "700",
                fontSize: { xs: "body2.fontSize", sm: "body1.fontSize" },
              }}
            >
              info@margottobis.se
            </ButtonBase>
          </Box>
        </Box>
        <Box
          sx={{
            width: { xs: 100, sm: 140 },
            height: { xs: 100, sm: 140 },
            borderRadius: "50%",
            bgcolor: "secondary.main",
            color: "secondary.light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: { xs: "h2.fontSize", sm: "h1.fontSize" },
          }}
        >
          <Mail fontSize="inherit" color="inherit" />
        </Box>
      </Box>
    </Box>
  );
};

export default Address;
